/**
 * SoldMoreButton
 * 
 * @Author: Focci
 * @Date: 2024-06-14 15:06:22
 * @Last Modified by: Focci
 * @Last Modified time: 2024-06-14 15:06:22
 */

'use client'

// import PropTypes from 'prop-types'
import useTracking from '@hook/useTracking'
import useProgressRouter from '@hook/useProgressRouter'
import { Button } from '@comp/material'
import { useLocale, useTranslations } from 'next-intl'
import { useCallback } from 'react'
import { houseSearchType } from '@lib/config'
import { generateUrl } from '@lib/utils'
import { urls } from '@lib/parse'

export default function SoldMoreButton({ house }) {
  const { pushTrackListingClick } = useTracking()
  const { routerPush } = useProgressRouter()

  const locale = useLocale()
  const th = useTranslations('house')
  const { propertyId, suburbName, suburbId, lng, lat } = house
  
  const showLink = Boolean(lng && lat && suburbName && suburbId)
  const url = generateUrl(
    urls.listing(houseSearchType.sold, {
      suburb: [{ label: suburbName, value: suburbId }],
      page: 1
    }, locale, true),
    {
      zoom: 18,
      showmap: 1,
      center: [lng, lat].join(','),
      propertyId,
    }
  )

  const handleClick = useCallback(() => {
    routerPush(url)
    pushTrackListingClick('sold_nearby-map', house)
  }, [house, pushTrackListingClick, routerPush, url])

  return showLink && (
    <div className="mt-6 text-center">
      <Button size="large" onClick={handleClick}>
        <div className="px-8">
          {th('showOnMap')}
        </div>
      </Button>
    </div>
  )
}

// SoldMoreButton.propTypes = {
//   className: PropTypes.string,
// }
